module.exports = fox._r("images/favorites-hover.png", __webpack_public_path__ + "images/favorites-hover.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/favorites-hover.png
// module id = 1044
// module chunks = 4